import { payments, recharge, languageApi2, languageApi } from '../../api/apiIndex'
import axios from 'axios';

export default {
  state: {
    language: {
      icon: null,
      option: "",
      value: ""
    },
    languageList: []
  },
  getters: {},
  mutations: {
    setLanguage(state, language) {
      state.language = language
    },
    setLanguageList(state, data) {
      state.languageList = data
    }
  },
  actions: {
    async getLanguage(context) {
      let data = { name: '' }

      if (window.location.host.includes('localhost')) {
        context.commit('setLanguageList', [
          {
            "value": "pt",
            "label": "Português",
            icon: require("../../static/img/Brazil.svg")
          },
          {
            "value": "en",
            "label": "English",
            icon: require("../../static/img/America.svg")
          }
        ])

        data.name = location.hostname =='localhost'? 'p9bet.live' : location.hostname;
      } else {
        data.name = window.location.host
      }

      await languageApi(data).then(res => {
        let arr = [];
        arr = res.languageList.map(v => {
          switch (v.value) {
            case 'en':
              v.icon = require("../../static/img/America.svg")
              return v
              break;
            case 'zh_cn':
              v.icon = require("../../static/img/Brazil.svg")
              return v
              break;
          }
        })
        if(arr.length > 0) context.commit('setLanguageList', arr)
      }).catch(err => {
        // 
      })
    },
    setLanguage(context, item) {
      localStorage.setItem("language", JSON.stringify(item));
      context.commit('setLanguage', item)
    },

    // NOT USED 
    async getLanguageList(context) {
      try {
        const response = await languageApi2({sitename: location.hostname =='localhost'? 'p9bet.live' : location.hostname});
        // this.siteLogo = response.data.site_logo;

        context.commit('setLanguageList', response.data.supported_language.map(lang => ({
          icon: lang.language_flag_link,
          option: lang.language_name,
          value: lang.language_code.endsWith('1') ? lang.language_code.slice(0, -1).toLowerCase() : lang.language_code.toLowerCase()
        })));
        context.dispatch('setLanguage', response.data.supported_language.map(lang => ({
          icon: lang.language_flag_link,
          option: lang.language_name,
          value: lang.language_code.endsWith('1') ? lang.language_code.slice(0, -1).toLowerCase() : lang.language_code.toLowerCase()
        }))[0])

      } catch (error) {
        console.error('Error fetching site data:', error);
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/vuex/modules/lang.js